// extracted by mini-css-extract-plugin
module.exports = {"check":"CheckSelect_check__WUEpw","title":"CheckSelect_title__1bheX","checkItems":"CheckSelect_checkItems__3L-0t","checkItem":"CheckSelect_checkItem__3sAgE"};